<template>

  <b-form-group :label="label" :label-for="name">
    <b-form-select :id="name" :name="name"
                   v-bind:value="value" v-on:input="$emit('input', $event)"
                   :text-field="textField"
                   :value-field="valueField"
                   v-validate="validate"
                   :state="errors.has(name) ? false : null"
                   :aria-describedby="name + 'Feedback'">

      <template v-for="option in placeHolderOptions">
        <option :value="option[valueField]">
          {{option[textField]}}
        </option>
      </template>

      <template v-for="option in highlightedOptions">
        <option :value="option[valueField]">
         {{option[textField]}}
        </option>
      </template>

      <option disabled v-if="hasHighlightedOptions">────────────────────</option>

      <template v-for="option in regularOptions">
        <option :value="option[valueField]">
         {{option[textField]}}
        </option>
      </template>

    </b-form-select>
    <b-form-invalid-feedback :id="name + 'Feedback'">{{errors.first(name)}}</b-form-invalid-feedback>
  </b-form-group>

</template>

<script>
  export default {
    props: {
      label: {
        type: String,
      },
      name: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      options: {
        required: true
      },
      value: {
        required: true
      },
      validate: {
        default: ''
      },
      validator: {
        type: Object,
      },
      textField: {
        required: false,
        default: 'text'
      },
      valueField: {
        required: false,
        default: 'value'
      }
    },
    methods: {
      populateOptions() {
        this.selectOptions = [...this.options]
        if (this.placeholder) {
          let placeHolderRow = {}
          placeHolderRow[this.textField] = this.placeholder
          placeHolderRow[this.valueField] = null
          this.selectOptions.unshift(placeHolderRow)
        }
      }
    },
    data() {
      return {
        selectOptions: [],
      }
    },
    computed: {
      hasHighlightedOptions() {
        return this.selectOptions.some(o => o.highlighted);
      },
      highlightedOptions() {
        return this.selectOptions.filter(option => option.highlighted);
      },
      placeHolderOptions() {
        return this.selectOptions.filter(option => option[this.valueField] === null);
      },
      regularOptions() {
        return this.selectOptions.filter(option => !option.highlighted && option[this.valueField] != null);
      }
    },
    created() {
      this.$validator = this.validator
      this.populateOptions()
    },
    watch: {
      options() {
        this.populateOptions()
      }
    }
  }
</script>
